const IDLE_CALLBACK_FALLBACK_TIMEOUT = 2000;
export const executeAtLowerPriority = callback => {
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(callback);
  } else {
    setTimeout(callback, IDLE_CALLBACK_FALLBACK_TIMEOUT);
  }
};